import styled from 'styled-components';

export const ClickableName = styled.div`
  min-width: 0;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
